import React from 'react';

import { Alert, Stack } from '@mui/material';

import { useCatalogueStaleness } from '~/hooks/apis/connectivity/useCatalogueStaleness';

export default function CatalogueStaleBanner() {
  const { data } = useCatalogueStaleness();
  const stale = data?.result?.stale ?? [];

  if (stale.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {stale.map((chain) => (
        <Alert key={chain.chainId} severity="error">
          {chain.message}
        </Alert>
      ))}
    </Stack>
  );
}
